import React from "react";
import "./../Homepage.css";
import "./weekly.css";

import 'react-slideshow-image/dist/styles.css';
import { Slide } from 'react-slideshow-image';

import inspoSide from "./../photos/geo-pyramid/inspo-side.webp";
import inspoTop from "./../photos/geo-pyramid/inspo-top.webp";
import onelayer from "./../photos/geo-pyramid/1layer.webp";
import model from "./../photos/geo-pyramid/model.webp";
import blockModel from "./../photos/geo-pyramid/block-model.webp";
import toolpath from "./../photos/geo-pyramid/toolpath.webp";
import stlmodel from "./../models/twisted_pyramid_sam.stl";
import waxSide from "./../photos/geo-pyramid/wax-side.webp";
import waxTop from "./../photos/geo-pyramid/wax-top.webp";
import siliconePour from "./../photos/geo-pyramid/silicone-pour.webp";
import bubbleMold from "./../photos/geo-pyramid/bubble-mold.webp";
import newMold from "./../photos/geo-pyramid/new-mold.webp";
import dsPour from "./../photos/geo-pyramid/ds-pour.webp";
import dsSide from "./../photos/geo-pyramid/ds-side.webp";
import dsTop from "./../photos/geo-pyramid/ds-top.webp";
import dsClose from "./../photos/geo-pyramid/ds-close.webp";

const slide1 = [{image: dsPour, caption: "Pouring the drystone into the molds"},
                {image: dsSide, caption: "Side view of the completed casts"},
                {image: dsTop, caption: "Top view of the completed casts"},
                {image: dsClose, caption: "Closer view of the cast on the better mold"}];

const Week7 = (props) => {
    return (
        <div className="HP-module">
            <div className="HP-subtitle">Week 7</div>
            <div className="HP-flex">
                <div className="HP-half HP-body">
                    This week we take a break from the electronic deign and fabrication process to look at 3D molding and casting. 
                    Our goal for the week is to machine a part out of machineable wax and use it to cast a silicone mold, which in turn can 
                    be used to cast parts in all sorts of materials. For my mold, I did some googling for inspiration and stumbled upon a 
                    cool looking twisted pyramid, and decided to go with that. I downloaded the stl file <a href="https://www.thingiverse.com/thing:2317931">here</a> and 
                    imported it into Fusion360. There was an issue, however, with the top-down view of the model. As you can see on the right, 
                    the twisted sections of the pyramid created overhangs on the layer below, effectively making the pyramid impossible to machine with 
                    our top-down process. Not to be thwarted, I took advantage of my new CAD skills and created my own version of the twisted pyramid, 
                    making sure that the layers did not cause overhangs and could threrefore be machined top-down. Finally, to complete the CAD model,
                    I added the 1.5"x3"x7" wax block that EDS stocks to the model, cut out a section to hold the pyramid, and moved the pyramid into the 
                    hole. It was also important to scale the mold to make sure that the walls of the wax block were always greater than 0.2" and the space 
                    between the walls and the model was 0.2" to make sure the wax would keep structural integrity and to make sure the silicone mold would 
                    be solid enough to function. The complete model can be found <a download href={stlmodel}>here</a>.
                </div>
                <div className="HP-photoContent HP-half">
                    <div className="HP-photoObject">
                        <img src={inspoSide} className="HP-medPhoto" style={{marginTop:"20px"}}/>
                        <div className="HP-caption">Twisted Pyramid inspiration</div>
                    </div>
                    <div className="HP-photoObject">
                        <img src={inspoTop} className="HP-medPhoto"/>
                        <div className="HP-caption">Top view of twisted overhangs</div>
                    </div>
                </div>
            </div>
            <div className="HP-photoContainer" style={{alignItems:"center", justifyContent:"space-evenly"}}>
                <div className="HP-photoObject">
                    <img src={onelayer} className="HP-medPhoto"/>
                    <div className="HP-caption">1 layer of the twisted pyramid</div>
                </div>
                <div className="HP-photoObject">
                    <img src={model} className="HP-medPhoto"/>
                    <div className="HP-caption">Completed redesign of the twisted pyramid</div>
                </div>
                <div className="HP-photoObject">
                    <img src={blockModel} className="HP-medPhoto"/>
                    <div className="HP-caption">The model inside of the wax block</div>
                </div>
            </div>
            <div className="HP-spacer" />
            <div className="HP-flex">
                <div className="HP-photoContent HP-half">
                    <div className="HP-photoObject">
                        <img src={toolpath} className="HP-largePhoto" style={{marginTop:"20px"}}/>
                        <div className="HP-caption">Twisted Pyramid toolpath</div>
                    </div>
                </div>
                <div className="HP-half HP-body">
                    The next step in the process was to turn my CAD model into CAM, or a machining path. I switched to the manufacture workflow 
                    in Fusion360 and began to setup my job. I created a new tool for the 0.25" diameter flat-end mill in lab, and entered conservative 
                    estimates for tool length to ensure no job failures from cutting too deep. I then added a 3D contour to the job to map out the surface 
                    of my pyramid, and specified the depth of cut for removing material to 0.2" to be conservative (roughly tool diameter). This programmed a 
                    2.5D pass, cutting horizontally at different layer heights. From here I could specify further 3D passes to add detail to my model, however 
                    very little of this was necessary due to the geometric nature of my model. I experimented with adding it anyways as well as removing excess material 
                    left out in the initial pass and created the toolpath seen to the left. I then simulated the job on my computer to make sure everything looked 
                    successful.
                </div>
            </div>
            <div className="HP-spacer" />
            <div className="HP-body">
                With the toolpath complete and tested, I exported the job to GCode and connected it to the machine. I calibrated the machine to set the origin at 
                the corner of my glued-down wax block, calibrated the z-axis, and began the job. The cutting was relatively quick due to the lack of long 3D passes 
                with the mill, and soon I had a nice model cut into the wax block.
            </div>
            <div className="HP-photoContainer" style={{alignItems:"center", justifyContent:"space-evenly"}}>
                <div className="HP-photoObject">
                    <img src={waxSide} className="HP-largePhoto"/>
                    <div className="HP-caption">Wax cutout of the model</div>
                </div>
                <div className="HP-photoObject">
                    <img src={waxTop} className="HP-largePhoto"/>
                    <div className="HP-caption">Top view of the detailed wax cutout</div>
                </div>
            </div>
            <div className="HP-spacer" />
            <div className="HP-flex">
                <div className="HP-half HP-body">
                    The next step in the process was to create the silicone mold from the wax block. For this step I used Oomoo, a two part mixture that 
                    creates a silicone mold after setting for roughly 2 hours. The Oomoo consists of a green part and a blue part, and they mix in equal 
                    parts by volume with a work time of 10s of minutes. I prepared myself with latex gloves and an apron and began to mix my Oomoo, mixing 
                    each part individually until consistent and then together until the color was consistent throughout the mixture. I noticed when mixing that 
                    my green part was very viscous, but I was warned that it was more viscous and decided to keep mixing. I began to pour the mixture into my mold 
                    with a narrow bead from a good height, and the mold began pouring well. After about 2-3 minutes, however, the Oomoo began to get very viscous, 
                    and was barely making it to the other half of my mold without being pushed into place. Since I was halfway through, I finished the pour and let 
                    the silicone set. Unsurprisingly, the resulting mold had bubbles in some of the areas where the Oomoo was poured later in the process. Talking to 
                    Anthony, this was likely due to the green part being old, and it was near end of life and had started to lose its efficacy, leading to the earlier 
                    hardening in my process. I repeated the process with a new bottle of green and found a much less viscous mixture which poured right into the wax mold 
                    and covered my model. After letting it set for a couple of hours, the new mold was much better and had practically no bubbles! Here are some photos of 
                    both molds, with a side by side for comparison (can you tell which is which?).
                </div>
                <div className="HP-photoContent HP-half">
                    <div className="HP-photoObject">
                        <img src={siliconePour} className="HP-medPhoto" style={{marginTop:"20px"}}/>
                        <div className="HP-caption">Finished pour of Oomoo</div>
                    </div>
                    <div className="HP-photoObject">
                        <img src={bubbleMold} className="HP-medPhoto"/>
                        <div className="HP-caption">Original mold with air bubbles</div>
                    </div>
                    <div className="HP-photoObject">
                        <img src={newMold} className="HP-largePhoto"/>
                        <div className="HP-caption">Comparison of old mold to new, better mold</div>
                    </div>
                </div>
            </div>
            <div className="HP-spacer" />
            <div className="HP-body">
                Now with the mold completed, it was time for the final step: cast a part from the silicone mold. I chose to use drystone in my cast, since 
                it was easy to work with and a good introduction to the casting process with forgiving mixing ratios and quick setting time. The instructions 
                provide a clear ratio of water to drystone powder involving the weights of the two, but a helpful demonstration from Anthony showed what the 
                consistency was we were aiming for (think yogurt), and with a large tolerance on either end mixing by feel was ok. I decided to mix enough 
                drystone to fill both the new mold and the bubbly mold so I could compare the quality of part that came out the other end, so I mixed a bunch of 
                drystone, poured into both molds with a thin bead from about 8" above the mold to reduce the bubbles, and waited about 45 minutes for the drystone 
                to set before removing the parts. At this point the casts were still fragile, but removing them from the molds as early as possible was reccomended 
                due to the exothermic nature of the hardening process (creates heat) as more surface area allows more heat to dissapate. Below are some photos of 
                the final casts with both the bubbly mold and the better one. Overall this project was fun, and the longest time spent was in creating the model and 
                waiting for setting times of silicone and drystone. The working time was not too intensive at all and the parts came out very well, and 
                I'll be sure to use these methods if I need to mass produce parts for my final project.
            </div>
            <div className="HP-spacer" />
            <Slide>
                {slide1.map((image) => <div className="HP-slideDiv" key={image.caption}>
                    <div className="HP-photoObject">
                        <img src={image.image} className="HP-slidePhotoLarge"/>
                        <div className="HP-caption">{image.caption}</div>
                    </div>
                </div>)}
            </Slide>
        </div>
    )
}

export default Week7;